// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('@babel/polyfill')
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import global from './utils/global.js'
import * as filters from './utils/filter.js'
import {DatePicker,Message,Dialog,Button,Input,Form,FormItem,Checkbox,CheckboxGroup,Radio,RadioGroup,Scrollbar,Upload,Select,Option} from 'element-ui'
import Meta from 'vue-meta'
import paginate from 'vuejs-paginate'

//import VueCropper from 'vue-cropper'
//Vue.use(VueCropper)

import VideoPlayer from 'vue-video-player'
require('vue-video-player/src/custom-theme.css')
require('video.js/dist/video-js.min.css')

Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.prototype.qs = qs           //全局注册，使用方法为:this.qs
Vue.config.productionTip = false
Vue.prototype.global = global
Vue.prototype.$message = Message

Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Scrollbar)
Vue.use(Upload)
Vue.use(Select)
Vue.use(Option)
Vue.use(Meta)
Vue.use(VideoPlayer)

Vue.component('paginate', paginate)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

router.afterEach((to,from,next) => {
  window.scrollTo(0,0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
